import React from "react";

const Health = () => {
  return (
    <div className="auto-container">
      <div className="row clearfix">
        <p>
          <strong>Ok! </strong>
        </p>
      </div>
    </div>
  );
};

Health.propTypes = {};

export default Health;
